<template>
  <div class="linexo-mini-calculation">
    <section class="linexo-mini-calculation__form">
      <OStepper v-if="currentStep" :current-step="currentStep" :is-loading="isFormSchemaLoading" :steps="steps" />
    </section>
    <section class="linexo-mini-calculation__result">
      <MiniResult
        :is-valid="isValid"
        :savings="savings"
        :savings-percentage="savingsPercentage"
        :is-loading="isLoading"
        :has-valid-result="hasValidResult"
        :price="price"
      />
    </section>
    <section class="linexo-mini-calculation__footer">
      <span v-html="$t('content.footer_text')" />
    </section>
  </div>
</template>
<script lang="ts" setup>
import OStepper from '@/components/organisms/o-stepper/O-Stepper.vue'
import MiniResult from '../mini-result/MiniResult.vue'
import type { MiniCalculationProps } from './mini-calculation-props'

withDefaults(defineProps<MiniCalculationProps>(), { price: null })
</script>
<style lang="scss" scoped>
@import './mini-calculation.scss';
</style>
